angular
	.module 'App.Directive'
	.directive 'indeterminateState', ->
		require: '?ngModel'
		restrict: 'A'
		link: (scope, element, attributes) ->
			scope.$watch attributes['ngModel'], (value) ->
				element.prop 'indeterminate', value == null
